(function(){
  "use strict";

  angular
    .module('irricrops')


    .factory("EquipoRes", ['urls', '$resource', function(urls, $resource){
      return $resource(urls.BASE+'/equipo/:action', {},{

        //--------
        // GET
        //--------
        get:{
          method: 'GET',
          cache: true
        },
        getAlertas:{
          method: 'GET',
          params: {
            action: 'alerta'
          }
        },
        getPendiente:{
          method: 'GET',
          params: {
            action: 'pendiente'
          }
        },
        getCuarteles:{
          method: 'GET',
          params: {
            action: 'sectores-riego'
          }
        },
        getSectoresScholander:{
          method: 'GET',
          params:{
            action: 'bombas'
          }
        },
        getRiegos:{
          method: 'GET',
          params:{
            action: 'riego'
          }
        },
        getSchol:{
          method: 'GET',
          params:{
            action: 'bomba'
          }
        },





        //--------
        // POST
        //--------
        schol:{
          method: 'POST',
          params:{
            action: 'bomba'
          }
        },
        porometro:{
          method: 'POST',
          params:{
            action: 'porometro'
          }
        },
        encargado: {
          method: 'POST',
          params: {
            action: 'encargado'
          }
        }
      }); // Note the full endpoint address
    }])



  //actualmente usado en las rutas
  .factory("EquipoFac", ['$http', '$q','EquipoRes', 'urls', 'newCacheManager',
      function($http, $q, EquipoRes, urls, NCM){


        var cache = function(a){
          var nameData = a.nameData;
          var id       = a.id;
          var date     = a.date || null;
          var data     = {};
          var defered  = null;
          var dataAjax = a.dataAjax;
          var thenFn   = a.thenFn;
          var fn       = a.fn;
          var prom     = null;
          var dateUnix = moment(date).unix();

          if (angular.isDefined(NCM.get(nameData, id, dateUnix))) {
            defered = $q.defer();
            prom = defered.promise;
            data = {
              data: NCM.get(nameData, id, dateUnix),
              errors: false
            };
            defered.resolve(data);
            thenFn(data);
          }else{
            prom = EquipoRes[fn](dataAjax).$promise;
            prom.then(thenFn);
            prom.then(function(data){
              NCM.set(nameData, id, data.data, dateUnix);
            });
          }
          return prom;
        };


        return {
          getData: function(id, fecha){
            return EquipoRes.get({equipo_id: id, fecha: fecha});
          },
          getAlertas: function(data, thenFn){
            return cache({
              nameData: "equipo.alertas",
              id: data.equipo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getAlertas'
            });
          },
          getPendiente: function(data, thenFn){
            return cache({
              nameData: "equipo.pendiente",
              id: data.equipo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getPendiente'
            });
          },

          getCuarteles: function(id, fecha){
            //return EquipoRes.getCuarteles({equipo_id: id, fecha: fecha});
            thenFn = function(){};
            return cache({
              nameData: "equipo.cuarteles",
              id: id,
              dataAjax: {equipo_id: id},
              date: fecha || null,
              thenFn: thenFn,
              fn: 'getCuarteles'
            });
          },

          getSectoresScholander: function(data, thenFn){
            return cache({
              nameData: "equipo.sectoresScholander",
              id: data.equipo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getSectoresScholander'
            });
          },
          getScholander: function(data, thenFn){
            return cache({
              nameData: "equipo.scholander",
              id: data.equipo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getSchol'
            });
          },

          getRiegos: function(id, fecha, thenFn){
            //return $http.get(urls.BASE+'/programacion-riego',{params: {equipo_id: id, fecha:fecha}});
            return cache({
              nameData: "equipo.riegos",
              id: id,
              dataAjax: {equipo_id: id, fecha: fecha},
              date: fecha || null,
              thenFn: thenFn,
              fn: 'getRiegos'
            });
          }

        };
      }]);
})();
